import styled, { css } from 'styled-components';

export const Wrapper = styled.div<{ $minHeight?: number; $maxHeight?: number }>`
  display: flex;
  flex-direction: column;
  width: 100%;

  .html-editor-fallback {
    border: 1px solid ${({ theme }) => theme.colors.black3};
    border-radius: 6px;
    padding: 12px;
    line-height: 1.5;
    background-color: ${({ theme }) => theme.colors.white};
    overflow-y: auto;
    min-height: ${({ $minHeight }) => ($minHeight ? `${$minHeight}px` : '122px')};
    max-height: ${({ $maxHeight }) => ($maxHeight ? `${$maxHeight}px` : 'none')};
  }

  .html-editor-fallback:empty::before {
    content: attr(data-placeholder);
    color: ${({ theme }) => theme.colors.black5};
    pointer-events: none;
  }

  .html-editor-fallback[aria-disabled='true'] {
    color: ${({ theme }) => theme.colors.black6};
    background-color: ${({ theme }) => theme.colors.black2};
    cursor: not-allowed;
  }

  ${({ $minHeight }) =>
    $minHeight &&
    css`
      .ql-editor {
        min-height: ${$minHeight}px;
        overflow-y: auto;
      }
    `}

  ${({ $maxHeight }) =>
    $maxHeight &&
    css`
      .ql-editor {
        max-height: ${$maxHeight}px;
        overflow-y: auto;
      }
    `}
`;
